export default {
  padding: [0, '60px'],
  paddingMobile: [30, '20px'],
}
